<div class="w-100">
    <div matRipple class="file-tab-content w-100 cursor-pointer px-2" *ngFor="let tab of tabs" [ngClass]="{'active-file-tab font-weight-bold': isTabActive(tab.id)}" (click)="changeActiveTab(tab.id)">
        <mat-icon class="reference-color">folder</mat-icon>
        <span class="mr-2">{{countTabTypeFiles(tab.id)}}</span>
        <span>{{tab.name}}</span>
    </div>
</div>